import { type DevAnalyticsLogEntry, atomWithLocalStorage } from '@twisto/utils'

export const DEV_ANALYTICS_LOGS_STORAGE_KEY = 'dev-analytics-logs' as const

export const devAnalyticsLogsAtom = atomWithLocalStorage<
  DevAnalyticsLogEntry[]
>(DEV_ANALYTICS_LOGS_STORAGE_KEY, [])
